import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';

import "../scss/form-template.scss"

import Layout from "../components/Layout"
import Banner from "../components/Banner/Banner"

const FormTemplate = (props) =>{

  const location = useLocation();

  var GQLPage = props.GQLPage;
  var GQLModules = props.GQLModules;

  return(
    <div className={`form_template`}>
        <Layout seo_meta={GQLPage.seo_meta} menu_slug={GQLPage?.menu?.slug} popular_search={GQLPage?.menu?.popular_search} GQLPage={props.GQLPage}>
            {
                <Banner banner_section = {GQLPage?.banner_section} GQLModules={GQLModules} GQLPage={GQLPage} location={props.location} /> 
            }              
        </Layout>
    </div>
  )

}

export default FormTemplate